// Resposta e anexos novos viajam no mesmo request, então o corpo é multipart.
// Com FormData o interceptor de service/api.js não converte as chaves, que já
// vão em snake_case.
const buildAnswerFormData = ({
  answer,
  justify,
  questionAlternativeId,
  evidences = [],
} = {}) => {
  const formData = new FormData()

  formData.append('privacy_by_design_answer[answer]', answer ?? '')
  formData.append('privacy_by_design_answer[justify]', justify ?? '')
  formData.append(
    'privacy_by_design_answer[question_alternative_id]',
    questionAlternativeId ?? '',
  )
  Array.from(evidences).forEach((file) => formData.append('evidences[]', file))

  return formData
}

export default buildAnswerFormData
